import { render } from "./ActualTask.vue?vue&type=template&id=f206b17a&scoped=true"
import script from "./ActualTask.vue?vue&type=script&lang=js"
export * from "./ActualTask.vue?vue&type=script&lang=js"

import "./ActualTask.vue?vue&type=style&index=0&id=f206b17a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f206b17a"

export default script